import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * Projects a custom header template into {@link TrTableComponent}, keyed by column.
 * When absent the shell renders its default header (sortable link or plain label)
 * plus the options menu and resize handle.
 *
 * Usage: `<ng-template trHeaderCell="select" let-col> … </ng-template>`.
 * The template's context is `{ $implicit: column }`.
 */
@Directive({
  selector: '[trHeaderCell]',
  standalone: false,
})
export class TrHeaderCellDirective {
  /** Column key this header renders (matches `TrColumn.key`). */
  @Input('trHeaderCell') key!: string;

  constructor(public readonly template: TemplateRef<unknown>) {}
}
